import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import HomePageLayout from './HomePageLayout';

class LookupLayout extends React.Component {
  componentDidMount() {
    this.props.setRxFormValues(this.props.match.params);
    this.props.dispatch(submit('RxLookupForm'));
  }

  render() {
    const { getRxConnect, match } = this.props;
    return (
      <HomePageLayout rxLookup={match.params} getRxConnect={getRxConnect} />
    );
  }
}
LookupLayout.propTypes = {
  match: PropTypes.any,
  setRxFormValues: PropTypes.func,
  getRxConnect: PropTypes.func,
  dispatch: PropTypes.func,
};

export default connect()(LookupLayout);



// WEBPACK FOOTER //
// ./src/containers/HomePage/LookupLayout.jsx